import React from 'react';
import { createUseStyles } from 'react-jss';
import variables from '../../theme/variables';

const useStyles = createUseStyles(
    {
        copy: {
            fontFamily: variables.typography.segoe,
            fontSize: 16,
            lineHeight: '22px',
            margin: 0,
            width: '100%',

            '@media (min-width: 1024px)': {
                fontSize: 20,
                lineHeight: '32px',
            },

            '& p': {
                marginBottom: '1em',
            },
        },
    },
    { name: 'SecondaryCopy' }
);

export default function SecondaryCopy({ children }) {
    const classes = useStyles();

    return <div className={classes.copy}>{children}</div>;
}
